// export const baseUrl = "https://androiddev.sevenup.org/scaleup/api/Registration/";
export const baseUrl = "https://po.sevenup.org/scaleup/api/";